import { render } from "./BusinessHistory.vue?vue&type=template&id=6a96b2a0&scoped=true"
import script from "./BusinessHistory.vue?vue&type=script&lang=js"
export * from "./BusinessHistory.vue?vue&type=script&lang=js"

import "./BusinessHistory.vue?vue&type=style&index=0&id=6a96b2a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a96b2a0"]])

export default __exports__